var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:(_vm.bgSide)},[_c('v-main',[_c('Header'),_c('v-row',[_c('v-col',{attrs:{"cols":"1"}}),_c('v-col',{attrs:{"cols":"10"}},[_c('router-view')],1),_c('v-col',{attrs:{"cols":"1"}})],1),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }